import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  eventStatus: 'published',
  selectedEvent: null,
  selectedAgeResult: null,
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    eventStatusUpdate: (state, action) => {
      state.eventStatus = action.payload;
    },
    updateSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
    updateSelectedAgeResult: (state, action) => {
      state.selectedAgeResult = action.payload;
    },
  },
});

export const {
  eventStatusUpdate,
  updateSelectedEvent,
  updateSelectedAgeResult,
} = eventSlice.actions;
export default eventSlice.reducer;
